import { Paper, Typography, Card, CardMedia, CardContent, Stack, Chip, Button } from '@mui/material';
import { Link } from 'react-router-dom';

import contents from './contents.json'; 

const ContentList = (props) => {

	const { limit } = props;
	const displayedContents = limit ? contents.slice(0, limit) : contents;

	return (
		<Stack spacing={2} direction="column" width="100%">
			{displayedContents.map((content, index) => (
				<Card key={index} elevation={4} sx={{ display: 'flex', flexDirection: 'row', height: '100%' }}>							
					<CardMedia
						component="img"
						sx={{ width: 200, height: '100%', objectFit: 'cover' }}
						image={content.image}
						alt={content.title}
					/>
					
					<CardContent sx={{ flexGrow: 1 }}>
						<Typography variant="h6" gutterBottom>{content.title}</Typography>
						<Typography variant="subtitle2" color="text.secondary">Por {content.author}</Typography>
						<Stack direction="row" spacing={1} sx={{ my: 1, flexWrap: 'wrap' }}>
							{content.tags.map((tag) => (
							<Chip key={tag} label={tag} size="small" />
							))}
						</Stack>
						<Typography variant="body2" paragraph 
							sx={{ display: "-webkit-box",
								WebkitLineClamp: 6,
								WebkitBoxOrient: "vertical",
								overflow: "hidden",
								textOverflow: "ellipsis"
							}}>
							{content.summary}
						</Typography>
						<Button variant="contained" size="small" component={Link} to={"/content/" + content.file}>Ler artigo</Button>
					</CardContent>
				</Card>					
			))}
		</Stack>
	)
}

export default ContentList;